<!-- start main-wrapper section -->
<div theme>
    <app-header></app-header>
    <router-outlet></router-outlet>

    <app-footer></app-footer>

    <app-scroll-top></app-scroll-top>
</div>
<!-- end main-wrapper section -->